import * as React from "react"

const MOBILE_BREAKPOINT = 768

// Tablet portrait is ~768px and landscape is ~1024px. The nav sidebar's 256px
// rail leaves tablet layouts far too little room (portrait ~512px, landscape
// ~768px), so the sidebar treats anything at or below this width as "collapse
// to the off-canvas / mobile shell". True desktop (>= 1025 / Tailwind `xl`)
// keeps the persistent rail. This is intentionally SEPARATE from
// MOBILE_BREAKPOINT so phone-only behavior (if ever added) stays at 768.
const TABLET_BREAKPOINT = 1024

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

/**
 * useIsTabletOrBelow — true at tablet portrait/landscape and phone widths
 * (viewport <= 1024px). Used by the nav sidebar to auto-collapse into the
 * off-canvas shell so tablets reclaim the 256px rail. Desktop (>= 1025 / `xl`)
 * returns false, so its layout is unchanged.
 */
export function useIsTabletOrBelow() {
  const [isTabletOrBelow, setIsTabletOrBelow] = React.useState<
    boolean | undefined
  >(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${TABLET_BREAKPOINT}px)`)
    const onChange = () => {
      setIsTabletOrBelow(window.innerWidth <= TABLET_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsTabletOrBelow(window.innerWidth <= TABLET_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isTabletOrBelow
}
